export enum Feature {
  BlindCount = 14,
  HotFoodBatches = 23,
  ShowIsbIngredientsTab = 27,
  StoreZeroErrors = 29,
  NewAlgorithm = 30,
}
